export function resetLoginUrl(email, next = null) {
  const params = new URLSearchParams({ e: email });
  if (next) params.set("next", next);
  return `/login?${params.toString()}`;
}
